export default __webpack_public_path__ + "static/media/cp_geo_sh.20ec88ca.svg";